var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallRedHeart2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83711 7.39323C3.83711 7.39323 1.71982 4.92694 1.12774 4.25079C0.38063 3.39672 -0.221784 1.72569 1.16169 0.757124C2.54518 -0.211447 3.91537 1.82007 3.93751 2.69581C3.93751 2.69581 4.56207 -0.541006 6.12273 0.323899C7.6834 1.18881 6.48005 3.44004 5.91159 4.60047C5.37507 5.64713 4.67371 6.59133 3.83711 7.39323Z",
    fill: "#D31C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83711 7.39323C3.83711 7.39323 1.71982 4.92694 1.12774 4.25079C0.38063 3.39672 -0.221784 1.72569 1.16169 0.757124C2.54518 -0.211447 3.91537 1.82007 3.93751 2.69581C3.93751 2.69581 4.56207 -0.541006 6.12273 0.323899C7.6834 1.18881 6.48005 3.44004 5.91159 4.60047C5.37507 5.64713 4.67371 6.59133 3.83711 7.39323Z",
    fill: "#D31C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRedHeart2);
export default __webpack_public_path__ + "static/media/SmallRedHeart (2).64d897e43b94fc5442563e4714fe29e6.svg";
export { ForwardRef as ReactComponent };